import { environment } from 'src/environments/environment';
import { AtLeast, PropertyExtractor } from './util';

export const alertActivity = {
	active: '0',
	inactive: '1',
	byDate: '2',
} as const;

export type Alert = {
	ID: number;
	Msg: string;
	MsgType: typeof MsgType[keyof typeof MsgType]['msgType'];
	Active: typeof alertActivity[keyof typeof alertActivity];
	Extra1: string;
	Extra2: string;
	CreateDate: string;
	Company: number;
	Name: string;
	JSON: { clients?: string[]; agents?: string[]; time?: string; date?: { start: string; end: string }; block?: boolean; doctypes?: number[]; selectProfit?: number };
};

// before JSON.parse()
export type AlertInDatabase = {
	[K in keyof Alert]: K extends 'JSON' ? string : Alert[K];
};

export interface AlertPostBody extends AtLeast<Alert, 'Msg'> {
	JSON: string;
}
/**
 * @description base message options
 * @property {boolean} clients - choose clients
 * @property {boolean} agents - choose agents
 * @property {boolean} timeSensitive - only certain time
 * @property {boolean} onlyOnce - alert only once per day/update
 * @property {boolean} block - activates history.back() on alert close
 */
const baseMessageOptions = { clients: true, agents: true, doctypes: false, timeSensitive: false, onlyOnce: false, block: true, selectProfit: false } as const;

export const MsgType = {
	afterUpdateLocal: { msgText: 'התראה לסוכן', msgType: '1000', options: { ...baseMessageOptions, clients: false, onlyOnce: true, block: false } },
	clientCard: { msgText: 'כניסה לכרטיס לקוח', msgType: '2000', options: { ...baseMessageOptions } },
	enterProducts: { msgText: 'התראה בהזמנת לקוח', msgType: '3000', options: { ...baseMessageOptions, doctypes: true } },
	enterProductsFromHour: { msgText: 'התראה בהזמנת לקוח - מתוזמנת', msgType: '3010', options: { ...baseMessageOptions, timeSensitive: true, doctypes: true } },
	moveToTeudaScreen: { msgText: 'לפני סיום הזמנה', msgType: '4000', options: { ...baseMessageOptions, doctypes: true } },
	moveToTeudaScreenFromHour: { msgText: 'לפני סיום הזמנה - מתוזמנת', msgType: '4010', options: { ...baseMessageOptions, timeSensitive: true, doctypes: true } },
	newVisit: { msgText: 'ביקור חדש', msgType: '5000', options: { ...baseMessageOptions } },
	profitPerTeuda: { msgText: 'רווחיות תעודה', msgType: '6000', options: { ...baseMessageOptions, doctypes: true, selectProfit: true, block: false } },
} as const;

type MsgTypeKeys = keyof typeof MsgType;

type MsgTypePropertyExtrator<K extends keyof typeof MsgType[MsgTypeKeys]> = PropertyExtractor<MsgTypeKeys, typeof MsgType, K>;

type MsgTypeType = MsgTypePropertyExtrator<'msgType'>;
type MsgTypeOptions = MsgTypePropertyExtrator<'options'>;
type MsgTypeText = MsgTypePropertyExtrator<'msgText'>;

export const msgTypeTypes: MsgTypeType = Object.fromEntries(Object.entries(MsgType).map(([name, msg]) => [name, msg.msgType])) as MsgTypeType;

export const MsgTypeOptions: MsgTypeOptions = Object.fromEntries(Object.values(MsgType).map(({ msgType, options }) => [msgType, options])) as MsgTypeOptions;

export const MsgTypeText: MsgTypeText = Object.fromEntries(Object.values(MsgType).map(({ msgType, msgText }) => [msgType, msgText])) as MsgTypeText;
